<template>
  <div class="min-h-screen bg-gray-100 dark:bg-gray-900 overflow-x-hidden">
    <!-- Header Component (Always Visible) -->
    <Header />
    <!-- Dynamic Page Content -->
    <main>
      <router-view />  <!-- Dynamically changes based on the route -->
    </main>

    <Footer />
  </div>
</template>

<script setup>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

</script>

<style>
/* Global Styles */
body {
  font-family: 'Inter', sans-serif;
}
html {
  scroll-behavior: smooth;
}
</style>